import { get, post } from "../../../utils/request";

const BASE_URL = "/sunAdmin/timerTask";

/**
 * 获取任务列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getTaskList(params = {}) {
    return post(`${BASE_URL}/getTaskList`, params);
}

/**
 * 保存任务（新增/编辑）
 * @param {Object} params 任务数据
 * @returns {Promise}
 */
export function save(params = {}) {
    return post(`${BASE_URL}/save`, params);
}

/**
 * 获取任务日志
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getTaskLogs(params = {}) {
    return post(`${BASE_URL}/getTaskLogs`, params);
}

/**
 * 手动执行任务
 * @param {Number} taskId 任务ID
 * @returns {Promise}
 */
export function manualExecuteTask(taskId) {
    return post(`${BASE_URL}/manualExecute`, { id: taskId });
}

// 导出所有API函数
export default {
    getTaskList,
    save,
    getTaskLogs,
    manualExecuteTask,
};
